import { Component, OnInit, ElementRef, ViewChild, Directive } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { DataserviceComponent } from './../shared/dataservice/dataservice.component'
import { FormBuilder, FormGroup, FormControl, Validators, FormArray, AbstractControl } from '@angular/forms';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Observable, Timestamp } from 'rxjs/Rx'
import { FetchdataServiceService } from '../fetchdata-service.service';
import { CaseDetails, Case, AttachmentsDetails, ArrAttachmentsDetails, Results, DealerInfo, Dealer } from '../case-details';
import { VINServiceService } from '../vinservice.service';
import { CookieService } from 'ngx-cookie-service';
//export function getTemplatebyLang(template: string) {
//  return './create-case.component.html';
//}

@Component({
  selector: 'app-create-case',
  //templateUrl: "'" + getTemplatebyLang('2') + "'",
  templateUrl: './create-case.component.html',
  styleUrls: ['./create-case.component.css']
})
export class CreateCaseComponent implements OnInit {
  myForm1: FormGroup;
  myForm2: FormGroup;
  myForm3: FormGroup;
  myForm4: FormGroup;

  caseDetails: CaseDetails;
  private arrAttachments: ArrAttachmentsDetails[];

  showPage1: Boolean = true;
  showPage2: Boolean;
  showPage3: Boolean;
  showPage4: Boolean;
  loc: string = 'en';

  //@ViewChild('hiddenVin', { static: true }) hiddenVin: ElementRef;
  myVin: Boolean = true;
  myMileage: Boolean = true;
  myDealer: Boolean = true;
  enTemplate: Boolean = true;
  ShowSpinner: Boolean = false;

  constructor(private route: ActivatedRoute, public dataservice: DataserviceComponent, private fb: FormBuilder, private srv: FetchdataServiceService, private validatevin: VINServiceService, private cookieService: CookieService) { }

  ngOnInit() {

    this.loc = this.route.snapshot.queryParamMap.get('loc');

    if (this.loc != null) {
      if (this.loc == 'fr')
        this.enTemplate = false;
      else
        this.enTemplate = true;
    } else {

      if (this.cookieService.get('lang') == 'fr')
        this.enTemplate = false;
      else
        this.enTemplate = true;

    }

    this.myForm1 = this.fb.group({
      firstName: ['', [Validators.required, Validators.pattern('^[A-Za-zÀ-ÿ ]{1,32}')]],
      lastName: ['', [Validators.required, Validators.pattern('^[A-Za-zÀ-ÿ ]{1,32}')]],
      email: ['', [Validators.required, Validators.pattern('^[A-Za-zÀ-ÿ0-9._%+-]+@[A-Za-zÀ-ÿ0-9.-]+\.[A-Za-zÀ-ÿ]{2,4}$')]],
      title: ['', [Validators.pattern, Validators.pattern('^.{1,500}$')]],
      phone: ['', [Validators.required, Validators.pattern(/^\(\d{3}\)\s\d{3}-\d{4}$/)]],
      address1: ['', [Validators.pattern, Validators.pattern('^.{1,500}$')]],
      address2: ['', [Validators.pattern, Validators.pattern('^.{1,500}$')]],
      city: ['', [Validators.pattern, Validators.pattern('[A-Za-zÀ-ÿ ]{1,32}')]],
      province: ['', [Validators.pattern, Validators.pattern('[A-Za-zÀ-ÿ ]{1,32}')]],
      postalCode: ['', [Validators.pattern, Validators.pattern(new RegExp(/^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]( )?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/i))]]

    });

    this.myForm4 = this.fb.group({
      range: [{ value: '10', disabled: false }, [Validators.required]],
      postalCode: ['', [Validators.required, Validators.pattern, Validators.pattern(new RegExp(/^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]( )?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/i))]],
      dealers: new FormArray([]),
      location: ['postal'],
      dealerName: ['', [Validators.pattern, Validators.pattern('[A-Za-z ]{1,32}')]]
    });

    this.caseDetails = new CaseDetails();
    this.arrAttachments = new Array();
    this.myForm1.markAsDirty();
    this.fileCounter = 0;
    //this.geturl();
  }

  async geturl() {
    this.Url = this.dataservice.arrTranslations[0].APIContactusURL;//"https://localhost:44354/api/Contactus";
  }

  onSubmit1(form1: FormGroup) {
    //console.log('Valid?', form1.valid); // true or false
    //console.log('Name', form1.value.firstName);
    //this.myForm1.markAsDirty();

    if (!form1.valid)
      return;

    this.caseDetails.FirstName = form1.get("firstName").value.trim();
    this.caseDetails.LastName = form1.get("lastName").value.trim();
    this.caseDetails.ContactEmail = form1.get("email").value.trim();
    this.caseDetails.ContactTitle = form1.get("title").value;
    this.caseDetails.Phone = form1.get("phone").value.replace('(', '').replace(')', '').replace(' ', '').replace('-', '');

    this.caseDetails.Address1 = encodeURI(form1.get("address1").value);
    this.caseDetails.Address2 = encodeURI(form1.get("address2").value);
    this.caseDetails.City = form1.get("city").value;
    this.caseDetails.State = form1.get("province").value;
    this.caseDetails.Zip = form1.get("postalCode").value;

    this.myForm2 = this.fb.group({
      chkVehicles: ['', [Validators.required, Validators.pattern('^[0-9]*$')]],
      chkDealership: ['', [Validators.required, Validators.pattern('^[0-9]*$')]]
    });

    this.showPage1 = false;
    this.showPage3 = false;
    this.showPage2 = true;

  }

  GotoStep1(event: any) {
    this.showPage1 = true;
    this.showPage3 = false;
    this.showPage2 = false;

  }

  GotoStep2(event: any) {
    this.showPage1 = false;
    this.showPage3 = false;
    this.showPage2 = true;

  }

  ClearFields(formWhatever: FormGroup) {
    formWhatever.reset({
      title: '',
      departments: '',
      category: ''
    });

  }
  onSubmit2(form2: FormGroup) {
    //console.log('Valid?', form2.valid); // true or false

    if (!form2.valid)
      return;

    this.showPage1 = false;
    this.showPage2 = false;
    this.showPage3 = true;
    this.fileCounter = 0;
    //alert(form2.get("chkVehicles").value);

    if (form2.get("chkVehicles").value == 1 && form2.get("chkDealership").value == 0) {

      //document.getElementById('hiddenVin').classList.remove('hidden');
      //alert(this.hiddenVin.nativeElement);
      this.myVin = false;
      this.myMileage = false;
      this.myDealer = true;

      this.myForm3 = this.fb.group({
        vin: ['', [Validators.required, Validators.pattern('[A-Za-zÀ-ÿ0-9]{1,32}'), Validators.minLength(17)], this.validateVin.bind(this)],
        mileage: ['', [Validators.required, Validators.pattern('^[1-9][0-9]*$')]],
        category: ['', [Validators.required, Validators.pattern('[A-Za-zÀ-ÿ ]{1,32}')]],
        departments: ['', [Validators.required, Validators.pattern('^.{1,500}$')]],
        comments: ['', [Validators.required, Validators.pattern('(.|\n)*?')]],
        files: new FormArray([])
      });

    }
    else if (form2.get("chkVehicles").value == 1 && form2.get("chkDealership").value == 1) {

      this.myVin = false;
      this.myMileage = false;
      this.myDealer = false;

      //this.myForm4 = this.fb.group({
      //  Range: ['', [Validators.required]],

      //});

      this.myForm3 = this.fb.group({
        vin: ['', [Validators.required, Validators.pattern('[A-Za-z0-9]{1,32}'), Validators.minLength(17)], this.validateVin.bind(this)],
        mileage: ['', [Validators.required, Validators.pattern('^[1-9][0-9,]*$')]],
        dealership: ['', [Validators.required, Validators.pattern('^[0-9]*$')]],
        category: ['', [Validators.required, Validators.pattern('[A-Za-zÀ-ÿ ]{1,32}')]],
        departments: ['', [Validators.required, Validators.pattern('^.{1,500}$')]],
        comments: ['', [Validators.required, Validators.pattern('(.|\n)*?')]],
        files: new FormArray([])
      });

    }
    else if (form2.get("chkVehicles").value == 0 && form2.get("chkDealership").value == 1) {

      this.myVin = true;
      this.myMileage = true;
      this.myDealer = false;

      this.myForm3 = this.fb.group({
        dealership: ['', [Validators.required, Validators.pattern('^[0-9,]*$')]],
        category: ['', [Validators.required, Validators.pattern('[A-Za-zÀ-ÿ ]{1,32}')]],
        departments: ['', [Validators.required, Validators.pattern('^.{1,500}$')]],
        comments: ['', [Validators.required, Validators.pattern('(.|\n)*?')]],
        files: new FormArray([])
      });

    }
    else {

      this.myVin = true;
      this.myMileage = true;
      this.myDealer = true;

      this.myForm3 = this.fb.group({
        category: ['', [Validators.required, Validators.pattern('[A-Za-zÀ-ÿ ]{1,32}')]],
        departments: ['', [Validators.required, Validators.pattern('^.{1,500}$')]],
        comments: ['', [Validators.required, Validators.pattern('(.|\n)*?')]],
        files: new FormArray([])
        //fileDescription1: ['', [Validators.pattern, Validators.pattern('[A-Za-z ]{1,32}')]],
        //fileDescription2: ['', [Validators.pattern, Validators.pattern('[A-Za-z ]{1,32}')]],
        //fileName1: ['', [Validators.pattern, Validators.pattern('[A-Za-z ]{1,32}')]],
        //fileName2: ['', [Validators.pattern, Validators.pattern('[A-Za-z ]{1,32}')]]
      });

    }

  }

  onSubmit4(form4: FormGroup) {
    //alert(form4.get("postalCode").value);
    if (!this.myForm4.valid)
      return;

    this.GetDealers(form4.get("range").value, form4.get("postalCode").value, form4.get("dealerName").value);
  }

  onSubmit3(form3: FormGroup) {
    console.log('Valid?', form3.valid); // true or false

    if (!form3.valid)
      return;

    this.caseDetails.Category = form3.get("category").value;
    this.caseDetails.SubCategory = form3.get("departments").value;
    this.caseDetails.Description = encodeURI(form3.get("comments").value);

    if (typeof form3.get("vin") != 'undefined' && form3.get("vin") != null) {
      this.caseDetails.VIN = form3.get("vin").value;
    }

    if (typeof form3.get("mileage") != 'undefined' && form3.get("mileage") != null) {
      this.caseDetails.Mileage = form3.get("mileage").value;
    }

    if (typeof form3.get("dealership") != 'undefined' && form3.get("dealership") != null) {
      this.caseDetails.DealerCode = form3.get("dealership").value;
    }

    //here we need to make a post webapi call to kcicontactus controller.
    //this.getPosts();


    this.showPage1 = false;
    this.showPage2 = false;
    this.showPage3 = false;
    this.showPage4 = false;

    if (this.arrAttachments.length <= 0)
      this.createCase();
    else
      this.uploadFiles();

  }

  getFormattedTime() {
    var today = new Date();
    var y = today.getFullYear();
    // JavaScript months are 0-based.
    var m = today.getMonth() + 1;
    var d = today.getDate();
    var h = today.getHours();
    var mi = today.getMinutes();
    var s = today.getSeconds();
    return y + "-" + m + "-" + d + "-" + h + "-" + mi + "-" + s;
  }

  selectedFiles: FileList;
  filesToUpload: Array<File> = [];
  validFile: Boolean;

  arrAttachmentsObj: ArrAttachmentsDetails;
  fileCounter: Number = 0;
  get f() { return this.myForm3.controls; }
  get t() { return this.f.files as FormArray; }

  validateFile(name: String) {
    var ext = name.substring(name.lastIndexOf('.') + 1);
    if (ext.toLowerCase() == 'png' || ext.toLowerCase() == 'jpg' || ext.toLowerCase() == 'pdf') {
      return true;
    }
    else {
      return false;
    }
  }

  FileUpload(event: any, myForm: any) {

    this.selectedFiles = event.target.files;

    for (let ii = 0; ii < this.selectedFiles.length; ii++) {

      if (!this.validateFile(this.selectedFiles[ii].name)) {
        this.validFile = false;
        return false;
      }

      this.validFile = true;

      this.fileCounter = +this.fileCounter + 1;
      //alert(this.selectedFiles[0].name);

      this.t.push(this.fb.group({
        filename: [{ value: '', disabled: true }],
        description: [{ value: '', enabled: true }, [Validators.required, Validators.pattern('[A-Za-z0-9À-ÿ ]{1,32}'), Validators.maxLength(17)]],
        todaysdate: [{ value: '', disabled: true }]

      }));

      var tempFileName: String[];
      tempFileName = this.selectedFiles[ii].name.split('.');
      var finalFileName: String = tempFileName[0] + "_" + this.getFormattedTime() + "." + tempFileName[1];
      //console.log(finalFileName);

      this.arrAttachmentsObj = new ArrAttachmentsDetails();
      this.arrAttachmentsObj.FileId = this.fileCounter.toString();
      this.arrAttachmentsObj.FileName = finalFileName;
      this.arrAttachmentsObj.AttDescription = '';
      this.arrAttachmentsObj.TodaysDate = new Date().toISOString().slice(0, 10).toString();
      this.arrAttachments.push(this.arrAttachmentsObj);

      //Object.defineProperty(this.selectedFiles[ii], 'name', {
      //  writable: true,
      //  value: finalFileName
      //});

      //this.filesToUpload.push(this.selectedFiles[ii]);

      this.formData.append(finalFileName.toString(), this.selectedFiles[ii], finalFileName.toString());

      for (var i = 0; i < this.t.controls.length; i++) {
        //this.myFiles.push(e.target.files[i]);
        if (this.t.controls[i].get("description").value.toString().indexOf('object') > -1) {
          this.t.controls[i].get("filename").setValue(finalFileName);
        }
        else
          this.t.controls[i].get("filename").setValue(this.t.controls[i].get("filename").value);
        //alert(this.t.controls[i].get("description"));
        //this.t.controls[i].get("description").setValue('');
        if (this.t.controls[i].get("description").value.toString().indexOf('object') > -1) {
          this.t.controls[i].get("description").setValue('');
        }
        else {
          this.t.controls[i].get("description").setValue(this.t.controls[i].get("description").value);

          if (this.t.controls[i].get("description").valid == true)
            this.myForm3.markAsPristine();
        }

        this.t.controls[i].get("todaysdate").setValue(new Date().toISOString().slice(0, 10).toString());
      }


    }

  }

  // item: ArrAttachmentsDetails;
  DeleteFile($event, fileId: String, fileName: String, myForm: any) {
    //alert(JSON.stringify(this.myForm3.value, null, 4));
    //this.uploadFiles();

    this.t.removeAt(+fileId);
    $event.preventDefault();
    this.fileCounter = +this.fileCounter - 1;
    this.isDelete = "true";
    //for (let i = 0; i < this.arrAttachments.length; i++) {
    //  if (this.arrAttachments[i].FileId == fileId) {
    //    this.arrAttachments.splice(+fileId - 1, 1);
    //    break;
    //  }
    //}

    this.arrAttachments = this.arrAttachments.filter(item => item.FileName != fileName);
    //console.log(this.arrAttachments.length);

    const formData2: FormData = new FormData();

    for (let i = 0; i < this.arrAttachments.length; i++) {
      //if (this.formData.get(this.arrAttachments[i].FileName.toString()) != null)
      formData2.append(this.arrAttachments[i].FileName.toString(), this.formData.get(this.arrAttachments[i].FileName.toString()));
      console.log(this.arrAttachments[i].FileName.toString());
    }

    //formData2.forEach((value, key) => {
    //  console.log(key + value)
    //});

    this.formData = new FormData();
    this.formData = formData2;
  }

  isDelete: String = "";
  formData: FormData = new FormData();
  uploadFiles() {
    //const formData: FormData = new FormData();
    const files: Array<File> = this.filesToUpload;

    //for (let i = 0; i < files.length; i++) {
    //  var tempFileName = this.arrAttachments[i];
    //  //formData.append("files[]", files[i], files[i]['name']);

    //  //var finalFileName: String = tempFileName[0] + "_" + this.getFormattedTime() + "." + tempFileName[1];

    //  this.formData.append("files", files[i], tempFileName.toString());

    //}

    //console.log(formData.get('files'));
    //this.formData.forEach((value, key) => {
    //  console.log(key + value)
    //});


    const formData2: FormData = new FormData();

    for (let i = 0; i < this.arrAttachments.length; i++) {

      //if (this.formData.get(this.arrAttachments[i].FileName.toString()) != null)
      formData2.append("files", this.formData.get(this.arrAttachments[i].FileName.toString()));
      //formData2.append("files", this.formData.get("files"));
      //alert(this.arrAttachments[i].FileName.toString());
      //console.log("upload function" + this.arrAttachments[i].FileName.toString());
    }

    
    this.formData.forEach((value, key) => {
      console.log("key %s: value %s", key, value);

    })


    //if (this.isDelete != "true") {

      this.formData = new FormData();
      this.formData = formData2;
    //}


   
    formData2.forEach((value, key) => {
      console.log("key1 %s: value1 %s", key, value);

    })

    //return;
    

    this.srv.postFiles(this.Url + '/OnPostUploadAsync', this.formData).subscribe(
      res => {
      //alert("file upload complete");
        //alert(res.results + ' ' + res.count);

        if (res.results == 0)
          this.createCase();
        else {
          //here we need to show error message to user and ask him to try again.
          this.Error = true;
          this.showPage4 = false;
          this.showPage3 = true;
       
        this.mode = 'determinate';
      }
      
    }, error => {
      this.Error = true;
      this.showPage4 = false;
      this.showPage3 = true;
    });

  }

  private posts: any[];
  mode = 'indeterminate';
  //Url = "https://localhost:44354/api/Contactus"
  Url = "https://contactusapi.kia.ca/api/Contactus"
  //Url = "https://contactusapiuat.kia.ca/api/Contactus"

  CompleteCaseCreation(): void {
    //console.log(this.posts);
    //alert('complete');
  }

  getPosts(): void {

    this.srv.getData(this.Url).subscribe((res: any[]) => {
      this.posts = res;
      //this.Comp();
      this.mode = 'determinate';
      this.ShowSpinner = false;
    });

  }

  myCase: Case;
  Error: Boolean = false;
  myDealerInfo: DealerInfo;
  createCase(): void {
    this.ShowSpinner = true;
    for (var i = 0; i < this.t.controls.length; i++) {
      for (var j = 0; j < this.arrAttachments.length; j++) {

        if (this.arrAttachments[j].FileName == this.t.controls[i].get("filename").value) {
          this.arrAttachments[j].AttDescription = this.t.controls[i].get("description").value;
          console.log("createcasefile: " + this.t.controls[i].get("filename").value);
        }
      }
    }

    //return;
    this.myCase = new Case();
    this.myCase.CaseDetails = this.caseDetails;
    this.myCase.CaseDetails.AttachmentsDetails = this.arrAttachments;
    this.srv.postData(this.Url + '/createcase', this.myCase).subscribe((res: Results) => {
      //this.posts = res;
      //alert(res.success);
      this.mode = 'determinate';
      if (res.success == "0") {
        this.CompleteCaseCreation();
        this.Error = false;
        this.ShowSpinner = false;
        this.showPage4 = true;

      } else {
        this.Error = true;
        this.showPage4 = false;
        this.showPage3 = true;
      }
    }, error => { this.Error = true; this.showPage4 = false; this.showPage3 = true; });

  }

  bHideDealership: Boolean = true;
  bHideDealershipName: Boolean = true;

  ShowDealershipName(): void {
    this.tt.clear();
    if (this.myForm4.get("location").value == 'dealername') {
      this.bHideDealershipName = false;
      this.myForm4.get("range").disable();
      this.myForm4.controls['postalCode'].setErrors(null);
    }
    else {
      this.bHideDealershipName = true;
      this.myForm4.get("range").enable();
    }
  }
  //dealersData = [];
  ShowDealershipModal(): void {

    //$event.preventDefaul);
    this.bHideDealership = !this.bHideDealership;
    //alert(myform.get(1).value)

    this.selectedDealers = this.tt.value
      .filter(({ isChecked }) => isChecked)
      .map(({ dealercode }) => dealercode)

    var temp: any;
    for (var i = 0; i < this.selectedDealers.length; i++) {
      if (i == 0)
        temp = this.selectedDealers[i];
      else
        temp = temp + "," + this.selectedDealers[i];

    }
    this.myForm3.get("dealership").setValue(temp);

    //console.log(selectedSummon);

  }

  //selectedOptions(): any { // right now: ['1','3']

  //  for (var i = 0; i < this.tt.controls.length; i++) {
  //   //this.tt.controls[i].get("i").;
  //  }
  //}

  arrDealers: DealerInfo[];

  //private addDealerCheckboxes() {
  //  this.arrDealers.forEach((o, i) => {
  //    const control = new FormControl(i === 0); // if first item set to true, else false
  //    (this.myForm4.controls.dealers as FormArray).push(control);
  //  });
  //}

  selectedDealers: any[];
  get ff() { return this.myForm4.controls; }
  get tt() { return this.ff.dealers as FormArray; }
  GetDealers(kms: string, postalCode: string, dealerName: string): void {
    this.tt.clear();
    this.ShowSpinner = true;
    this.myDealerInfo = new DealerInfo();
    this.myDealerInfo.KMS = kms;

    if (postalCode == '')
      this.myDealerInfo.PostalCode = 'undefined';
    else
      this.myDealerInfo.PostalCode = postalCode;

    if (this.bHideDealershipName == true) {
      this.srv.postDealerInfoData(this.Url + '/GetDealers', this.myDealerInfo).subscribe((res: Dealer) => {
        //this.posts = res;
        //alert(res.success);
        this.mode = 'determinate';
        this.arrDealers = new Array();
        this.arrDealers = res.dealerInfo;
        //this.addDealerCheckboxes();
        var i = 0;

        for (let [key, value] of Object.entries(res.dealerInfo)) {
          this.tt.push(this.fb.group({
            dealercode: value.DealerCode,
            dealername: value.DealerName,
            dealeraddress: value.DealerAddress,
            dealertel: value.DealerTel,
            isChecked: false,

          }));

          i = i + 1;

        }
      }, error => { this.Error = true; this.showPage4 = false; this.showPage3 = true; });
    } else {
      this.srv.postDealerInfoData(this.Url + '/GetDealers', this.myDealerInfo).subscribe((res: Dealer) => {
        //this.posts = res;
        //alert(res.success);
        this.mode = 'determinate';
        this.arrDealers = new Array();
        this.arrDealers = res.dealerInfo;
        //this.addDealerCheckboxes();
        var i = 0;

        for (let [key, value] of Object.entries(res.dealerInfo)) {

          if (value.DealerName.toUpperCase().includes(dealerName.toUpperCase())) {
            this.tt.push(this.fb.group({
              dealercode: value.DealerCode,
              dealername: value.DealerName,
              dealeraddress: value.DealerAddress,
              dealertel: value.DealerTel,
              isChecked: false,

            }));
          }
          i = i + 1;

        }
      }, error => { this.Error = true; this.showPage4 = false; this.showPage3 = true; });

    }

  }


  validateVin(control: AbstractControl) {
    return this.validatevin.validateVIN(control.value).map(res => {
      return res.success == "true" ? null : { vinInvalid: true };
    });
  }

}
